var map = {
	"./parachute 1.jpg": 66745,
	"./parachute.jpg": 25108,
	"./rat 1.jpg": 95221,
	"./rocket 01.jpg": 34892,
	"./rocket 2.jpg": 23511,
	"./rocket 3.jpg": 59674,
	"./rocket.jpg": 13733,
	"./stilite 2.jpg": 3825,
	"./stilite 3.jpg": 89492,
	"./zirafee 1.jpg": 89044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24547;